import { useTeamMembersTableStore } from '../../store/myTeamTableStateStore';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { PinIcon } from 'foundations-assets';
import UsageTracker from '../../../../utils/UsageTracker';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentUserCell = ({
  children
}) => {
  const tableStore = useTeamMembersTableStore();
  const isUserPinned = tableStore.state.isUserPinned;
  const buttonText = isUserPinned ? I18n.text('learningCenter.myTeam.common.actions.unpinUser') : I18n.text('learningCenter.myTeam.common.actions.pinUser');
  return /*#__PURE__*/_jsx(TableHoverCell, {
    hoverContent: /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "pin-button",
      name: buttonText,
      onClick: () => {
        UsageTracker.track('teamInteraction', {
          action: isUserPinned ? 'unpin-user-clicked' : 'pin-user-clicked'
        });
        tableStore.actions.setIsUserPinned(!isUserPinned);
      },
      shape: "circle",
      size: "small",
      tooltip: buttonText,
      children: /*#__PURE__*/_jsx(PinIcon, {})
    }),
    children: children
  });
};
export default CurrentUserCell;